import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import Pagination from '../../../../components/pagination';
import { PAGE_SIZE } from '../../../../_common/constant';
import Search from '../../../../components/search';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';
import Button from '../../../../components/elements/button';

interface genProps {
	partDetails: any;
}
const LocationWiseStock: React.FC<genProps> = ({ partDetails }) => {
	const spearPartsAPI = useSpearPartsApi();
	const [gridApi, setGridApi] = useState<any>(null);
	const [gridColumnApi, setGridColumnApi] = useState<any>(null);
	const [totalRecords, setTotalRecords] = useState<number>(0);
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [searchParam, setSearchParam] = useState<string>('');

	const [rowData, setRowData] = useState<any>(null)

	const onGridReady = (params: any) => {
		setGridApi(params.api);
		setGridColumnApi(params.columnApi);
	};
	const onRowClicked = (event: any) => {
		if (!event.event.target.closest('input[type="checkbox"]')) {
			event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
		}
	};
	const getSpearPartsList = () => {
		spearPartsAPI.locationWiseStock({
			partsID: partDetails?.partsID,
			pageSize: PAGE_SIZE,
			pageNumber: currentPage,
			searchParam: searchParam,
		}, (data: any) => {
			setTotalRecords(data.totalRecord);
			setRowData(data.stockAdjustmentLocationWiseList ? data.stockAdjustmentLocationWiseList : []);
		}, (error: any) => {
			setRowData([]);
		});
	};

	useEffect(() => {
		getSpearPartsList();
	}, [currentPage, searchParam]);

	const columnDefs = [
		{ headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', minWidth: 200, flex: 1 },
		/* {
			headerName: 'Sub Facility', field: 'subFacilityName', headerClass: 'bg-[#f0f0f0]',
			cellRenderer: (data: any) => data.value ? data.value : '--'
		}, */
		{
			headerName: 'Bin', field: 'bin', headerClass: 'bg-[#f0f0f0]',
			cellRenderer: (data: any) => data.value ? data.value : '--'
		},
		{
			headerName: 'Aisle', field: 'aisle', headerClass: 'bg-[#f0f0f0]',
			cellRenderer: (data: any) => data.value ? data.value : '--'
		},
		{
			headerName: 'Qty on hand', field: 'qtyOnHand', headerClass: 'bg-[#f0f0f0]', flex: 1,
			cellRenderer: (data: any) => {
				const qtyOnHand = data.data?.qtyOnHand || '--';
				const unitName = data.data?.unitName || '';
				return `${qtyOnHand} ${unitName}`;
			}
		},
	];


	return (
		<div>

			<div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
				<div className='flex items-center gap-2'>
					<h1 className='text-[0.9rem] leading-[1]'>Stock by Location</h1>
					<Pagination
						perPage={PAGE_SIZE}
						totalRecords={totalRecords}
						onPageChange={setCurrentPage}
						currentPage={currentPage}
					/>
				</div>
				<div className='flex items-center gap-2'>
					<Search onSearch={setSearchParam} />
					<Button theme='light' disabled >Export</Button>
				</div>

			</div>
			<div>
				<div className='bg-[#FAFAFA]'>

					<div className="ag-theme-alpine h-1/2">
						<AgGridReact
							columnDefs={columnDefs} // Pass columnDefs
							rowData={rowData || []} // Pass rowData
							pagination={false}
							rowSelection="multiple"
							onGridReady={onGridReady}
							domLayout="autoHeight"
							onRowClicked={onRowClicked}
							noRowsOverlayComponent={() => (
								<div className="flex items-center justify-center h-full">
									<div className="text-center text-gray-500">
										<div className="text-lg font-medium">No Data Found</div>
									</div>
								</div>
							)}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default LocationWiseStock;